import React from "react";

const BlogDetailsSkeleton = () => {
    return (
        <section className="blog_wrap section_pb section_pt">
            <div className="container">
                <div className="row justify-content-center g-4">
                    <div className="col-md-9 col-sm-12 col-12">
                        {/* Title */}
                        <div className="skeleton-line title mb-3"></div>

                        {/* Image */}
                        <div className="skeleton-box blog-detail-image mb-4"></div>

                        {/* Content */}
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line short"></div>

                        <div className="skeleton-line mt-4"></div>
                        <div className="skeleton-line"></div>
                        <div className="skeleton-line short"></div>

                        {/* Tags */}
                        <div className="d-flex gap-2 mt-4">
                            {[1, 2, 3].map((i) => (
                                <div key={i} className="skeleton-box tag-skeleton"></div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BlogDetailsSkeleton;
